// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__MTP+X","input":"SearchBar_input__XeA2w"};